import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Button, IconButton, TextField } from "@material-ui/core";
import { List, ListItem, ListItemText } from "@material-ui/core";
import { CREATE_SHIP_ITEM, DELETE_SHIP_ITEM } from './shipbox_gql';
import DeleteIcon from '@material-ui/icons/Delete';

export default function ShipItemList(props) {
  const [newEan, setNewEan] = useState("");

  const createShipItem = useMutation(CREATE_SHIP_ITEM, {
    refetchQueries: [
      'GetShipBox'
    ], onCompleted: () => { setNewEan(""); }
  })[0];

  const deleteShipItem = useMutation(DELETE_SHIP_ITEM, {
    refetchQueries: [
      'GetShipBox'
    ]
  })[0];

  const deleteItem = (shipItemId) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      deleteShipItem({ variables: { shipItemId: shipItemId } });
    }
  }

  const handleNewEanUpdate = (e) => {
    setNewEan(e.target.value)
  }

  const addNewItem = () => {
    if (newEan !== "") {
      createShipItem({ variables: {shipBoxId: props.shipBox.shipBoxId, eanIn: newEan}});
    }
  }

  return (
    <List dense={true} disablePadding={true}>
      {props.shipBox.shipItems.map(si =>
        <ListItem key={si.shipItemId}>
          <ListItemText primary={si.item} />
          <IconButton size="small" edge="end" aria-label="delete" onClick={() => deleteItem(si.shipItemId)}><DeleteIcon /></IconButton>
        </ListItem>)}

      <ListItem key="new">
        <TextField id="new-ean" label="EAN" value={newEan} onChange={handleNewEanUpdate} />
        <Button variant="outlined" onClick={addNewItem} size="small">Add</Button>
      </ListItem>
    </List>
  )
}